/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Live_CaptioningInputs */



/**
* | output |
* | --- |
* | "Live Captioning" |
*
* @param {Quicktools_Tab_Live_CaptioningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_live_captioning = /** @type {((inputs?: Quicktools_Tab_Live_CaptioningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Live_CaptioningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titrage en direct")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Untertitelung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli in diretta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры в реальном времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtitulado en directo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("实时字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブキャプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas ao vivo")
	return /** @type {LocalizedString} */ ("Live Captioning")
});